import React, { useEffect, useRef, useState } from "react";
import {
  Stack,
  Box,
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
  Button,
} from "@mui/material";
import { useScroll } from "framer-motion";
import Lenis from "@studio-freight/lenis";
import { FaRegCircleCheck } from "react-icons/fa6";
import CTWA from "./svgImage/CWTA.webp";
import From from "./svgImage/Flow.webp";
import Template from "./svgImage/Template.webp";
import Intergration from "./svgImage/Payment.webp";
import Webview from "./svgImage/Webview.webp";
// import Webview from "./svgImage/ayarSirImg.png";
import { FaInfoCircle, FaUserPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { HiMiniCurrencyDollar } from "react-icons/hi2";
import Dollar from "./svgImage/dollar1.png";

const MainCardMobile = () => {
  const container = useRef(null);
  const { scrollYProgress } = useScroll({
    target: container,
    offset: ["start start", "end end"],
  });

  const [scales, setScales] = useState([]);

  // Dynamically calculate scales for each grid item based on scroll progress
  useEffect(() => {
    const unsubscribe = scrollYProgress.onChange((progress) => {
      const newScales = [0, 1, 2, 3, 4].map((i) => {
        return 1 - (5 - i) * 0.05 * progress; // Adjust scaling logic
      });
      setScales(newScales);
    });

    return () => unsubscribe();
  }, [scrollYProgress]);

  useEffect(() => {
    const lenis = new Lenis();

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
  }, []);

  const theme = useTheme();
  const navigate = useNavigate();

  const isXs = useMediaQuery(theme.breakpoints.down("xs"));
  const isSm = useMediaQuery(theme.breakpoints.between("xs", "sm"));
  const isMd = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isLg = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const isXl = useMediaQuery(theme.breakpoints.up("lg"));

  const getIconSize = () => {
    if (isXs) return 12; // Size for xs
    if (isSm) return 12; // Size for sm
    if (isMd) return 12; // Size for md
    if (isLg) return 12; // Size for lg
    if (isXl) return 16; // Size for xl
    return 12; // Default size
  };

  const handleClick1 = () => {
    // navigate("/solution1");
    navigate("/solution1", { state: { index: 0 } });
  };
  const handleClick2 = () => {
    // navigate("/card-info");
    navigate("/solution1", { state: { index: 1 } });
  };
  const handleClick3 = () => {
    // navigate("/card-info");
    navigate("/solution1", { state: { index: 2 } });
  };
  const handleClick4 = () => {
    // navigate("/card-info");
    navigate("/solution1", { state: { index: 3 } });
  };
  const handleClick5 = () => {
    // navigate("/card-info");
    navigate("/solution1", { state: { index: 4 } });
  };

  return (
    <Stack
      ref={container}
      sx={{
        display: { xl: "none", lg: "none", md: "none", sm: "none", xs: "flex" },
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        // background: "linear-gradient(to right, #cce7ff, #f4e3ff)", // Gradient background
        // backgroundColor: "white",
        // border: "1px solid red",
      }}
    >
      <Box
        sx={{
          width: {
            lg: "80%",
            xl: "70%",
            md: "85%",
            xs: "90%",
            sm: "100%",
          },
        }}
      >
        <Box
          component="ul"
          sx={{
            listStyle: "none",
            paddingLeft: 0,
            display: "grid",
            gridTemplateColumns: "1fr",
            gridTemplateRows: "repeat(5, auto)", // Kept auto for flexibility
            gap: "0vw",
            paddingBottom: "1em", // Slightly increased bottom padding
            marginBottom: "0",
          }}
        >
          <Grid
            key={`grid-${0}`}
            component="li"
            sx={{
              boxSizing: "border-box",
              padding: "30px",
              borderRadius: "20px",
              height: "67vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "sticky",
              // top: 80 + 0 * 35, // Adjust top for each grid
              top: isSm ? 50 + 0 * 35 : 80 + 0 * 35,
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              backdropFilter: "blur(8px)",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
              border: "1px solid rgba(255, 255, 255, 0.5)",
              // border: "2px solid red",
              transform: `scale(${scales[0] || 1})`, // Apply dynamic scaling
              transition: "transform 0.1s ease-in-out", // Smooth scaling animation
            }}
          >
            <Box
              sx={{
                //border: "1px solid red",
                backgroundColor: "white",
                width: "100%",
                height: "100%",
              }}
            >
              <Stack
                sx={{
                  width: "100%",
                  height: "100%",

                  display: {
                    lg: "flex",
                    xl: "flex",
                    sm: "flex",
                  },
                  flexDirection: {
                    lg: "row",
                    xl: "row",
                    md: "row",
                    sm: "column",
                  },
                  justifyContent: {
                    lg: "center",
                    xl: "center",
                    sm: "center",
                  },
                  alignItems: {
                    lg: "center",
                    xl: "center",
                    sm: "center",
                  },
                  gap: 2,
                  // background: "linear-gradient(to right, #cce7ff, #f4e3ff)", // Gradient background
                  //   background: "#F9E8FF", // Gradient background
                }}
              >
                <Stack
                  sx={{
                    //border: "2px solid green",
                    height: {
                      xs: "180%",
                    },
                    width: {
                      xs: "100%",
                    },
                    backdropFilter: "blur(12px)", // Frosted glass effect
                    backgroundColor: "rgb(245 241 238)",
                    overflow: "hidden", // Ensure internal content doesn't overflow
                    position: "relative", // Needed for shine effect
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "all 0.5s ease-in-out",
                  }}
                >
                  <Stack
                    sx={{
                      height: "100%",
                      width: "100%",
                      //border: "1px solid green",
                      marginTop: {
                        lg: "0px",
                        xl: "0px",
                        md: "0px",
                        xs: "0px",
                        sm: "0px",
                      },
                    }}
                  >
                    <img
                      src={CTWA}
                      alt="Image1"
                      style={{
                        height: "105%",
                        width: "100%",
                      }}
                    />
                  </Stack>
                </Stack>

                <Stack
                  sx={{
                    backgroundColor: "white",
                    //border: "1px solid red",

                    height: {
                      xs: "60%",
                    },
                    width: {
                      xs: "100%",
                    },

                    paddingTop: {
                      lg: "0px",
                      xl: "0px",
                      xs: "8px",
                      sm: "12px",
                    },
                    marginBottom: {
                      lg: "0px",
                      xl: "0px",
                      xs: "0px",
                      sm: "12px",
                    },
                  }}
                >
                  <Stack
                    sx={{
                      height: "100%",
                      marginTop: {
                        lg: "60px",
                        xl: "60px",
                        // md: "0px",
                        xs: "0px",
                        sm: "0px",
                      },
                    }}
                  >
                    <Stack
                      sx={{
                        // border: "1px solid red",
                        height: "auto",
                        // lineHeight: "48px",

                        lineHeight: {
                          lg: "32px",
                          xl: "40px",
                          md: "32px",
                          xs: "23px",
                          sm: "36px",
                        },
                        // fontSize: "39px",
                        fontSize: {
                          lg: "29px",
                          xl: "36px",
                          md: "24px",
                          xs: "18px",
                          sm: "28px",
                        },
                        fontFamily: "'Roboto', sans-serif",
                        fontWeight: "700",
                        color: "rgb(0, 0, 0)",
                        paddingLeft: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "0px",
                          sm: "40px",
                        },
                        paddingRight: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "0px",
                          sm: "40px",
                        },
                        marginBottom: {
                          lg: "20px",
                          xl: "20px",
                          md: "20px",
                          xs: "8px",
                          sm: "8px",
                        },
                        display: "flex",
                        flexDirection: "row",
                        gap: 1,
                      }}
                    >
                      <Stack>
                        <Stack
                          sx={{
                            // border: "1px solid red",
                            height: { xl: "100%", lg: "100%", xs: "100%" },
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Stack
                            sx={{
                              width: { xl: "8px", lg: "8px", xs: "4px" },
                              height: {
                                xl: "89%",
                                lg: "94%",
                                md: "90%",
                                sm: "80%",
                                xs: "93%",
                              },
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              // border: "1px solid red",
                              backgroundColor: "rgb(5 78 146)",

                              borderTopRightRadius: "8px", // Adjust the value as needed
                              borderBottomRightRadius: "8px", // Adjust the value as needed
                            }}
                          >
                            <h4 style={{ color: "rgb(5 78 146)" }}>{""}</h4>
                          </Stack>
                        </Stack>
                      </Stack>
                      <span>
                        {" "}
                        One - click chat with{" "}
                        <span style={{ color: "green" }}>WhatsApp</span>
                      </span>
                    </Stack>
                    <Stack
                      sx={{
                        height: "auto",
                        lineHeight: {
                          lg: "25px",
                          xl: "25px",
                          md: "32px",
                          xs: "20px",
                          sm: "20px",
                        },
                        // fontSize: "18px",
                        fontSize: {
                          lg: "20px",
                          xl: "20px",
                          md: "28px",
                          xs: "16px",
                          sm: "20px",
                        },
                        fontFamily: "'Roboto', sans-serif",
                        fontWeight: {
                          lg: "400",
                          xl: "400",
                          xs: "400",
                          sm: "400",
                        },
                        color: "rgb(0, 0, 0)",
                        // paddingLeft: "28px",
                        // paddingRight: "28px",
                        paddingLeft: {
                          lg: "28px",
                          xl: "28px",
                          md: "28px",
                          xs: "0px",
                          sm: "28px",
                        },
                        paddingRight: {
                          lg: "28px",
                          xl: "28px",
                          md: "28px",
                          xs: "0px",
                          sm: "28px",
                        },
                        // border: "1px solid blue",
                        marginBottom: {
                          lg: "20px",
                          xl: "20px",
                          md: "20px",
                          xs: "8px",
                          sm: "8px",
                        },
                      }}
                    >
                      <Stack
                        sx={{
                          height: "auto",
                          lineHeight: {
                            lg: "32px",
                            xl: "32px",
                            md: "24px",
                            xs: "20px",
                            sm: "20px",
                          },
                          // fontSize: "18px",
                          fontSize: {
                            lg: "20px",
                            xl: "20px",
                            md: "16px",
                            xs: "16px",
                            sm: "20px",
                          },
                          fontFamily: "'Roboto', sans-serif",
                          fontWeight: {
                            lg: "400",
                            xl: "400",
                            xs: "400",
                            sm: "400",
                          },
                          color: "rgb(0, 0, 0)",
                          // paddingLeft: "12px",
                          padding: "12px",
                          // paddingRight: "12px",
                          border: "1px solid rgb(245 241 238)",
                          backgroundColor: "rgb(245 241 238)",
                          borderRadius: "8px",
                          // marginTop: "12px",
                          display: {
                            xl: "flex",
                            lg: "flex",
                            md: "flex",
                            sm: "flex",
                            xs: "none",
                          },
                        }}
                      >
                        Engage customers directly through one simple click with
                        CTWA (click to WhatsApp ads).
                      </Stack>

                      <Stack
                        sx={{
                          height: "auto",
                          lineHeight: {
                            lg: "32px",
                            xl: "32px",
                            md: "24px",
                            xs: "24px",
                            sm: "20px",
                          },
                          // fontSize: "18px",
                          fontSize: {
                            lg: "20px",
                            xl: "20px",
                            md: "16px",
                            xs: "16px",
                            sm: "20px",
                          },
                          fontFamily: "'Roboto', sans-serif",
                          fontWeight: {
                            lg: "400",
                            xl: "400",
                            xs: "400",
                            sm: "400",
                          },
                          color: "rgb(0, 0, 0)",
                          // paddingLeft: "12px",
                          padding: "12px",
                          // paddingRight: "12px",
                          border: "1px solid rgb(245 241 238))",
                          backgroundColor: "rgb(245 241 238)",
                          borderRadius: "8px",
                          display: {
                            xl: "none",
                            lg: "none",
                            md: "none",
                            sm: "none",
                            xs: "flex",
                          },
                        }}
                      >
                        Engage customers with one click to start a WhatsApp
                        chat, no need to save numbers or switch apps, ensuring
                        effortless  communication.
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        height: "auto",
                        color: "rgb(73, 72, 72)",
                        // paddingLeft: "40px",
                        // paddingRight: "40px",
                        paddingLeft: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "12px",
                          sm: "40px",
                        },
                        paddingRight: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "12px",
                          sm: "40px",
                        },
                        //border: "1px solid red",
                      }}
                    >
                      <Stack>
                        <Stack
                          sx={{
                            display: {
                              lg: "flex",
                              xl: "flex",
                              md: "flex",
                              xs: "flex",
                              sm: "flex",
                            },
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          {/* <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                            }}
                          >
                            Seamless transition from ads to chat.
                          </Typography> */}
                        </Stack>
                        <Stack
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          {/* <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              display: {
                                xl: "flex",
                                lg: "flex",
                                md: "none",
                                sm: "flex",
                                xs: "flex",
                              },
                              // fontSize: "18px",
                              fontFamily: "'Roboto', sans-serif",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                            }}
                          >
                            Social media ads redirect to WhatsApp.
                          </Typography> */}

                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              display: {
                                xl: "none",
                                lg: "none",
                                md: "flex",
                                sm: "none",
                                xs: "none",
                              },
                              // fontSize: "18px",
                              fontFamily: "'Roboto', sans-serif",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                            }}
                          >
                            Facebook ads redirect to WhatsApp.
                          </Typography>
                        </Stack>
                        <Stack
                          sx={{
                            display: {
                              xl: "flex",
                              lg: "flex",
                              md: "flex",
                              sm: "flex",
                              xs: "none",
                            },
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                            }}
                          >
                            Boost conversions with direct interaction.
                          </Typography>
                        </Stack>
                        {/* <Stack
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                            }}
                          >
                            Precise targeting for high ROAS.
                          </Typography>
                        </Stack> */}

                        <Stack
                          sx={{
                            display: {
                              xs: "none", // Hide on extra small screens
                              sm: "none", // Hide on small screens
                              md: "flex", // Show on medium and larger screens
                              lg: "none",
                              xl: "flex",
                            },
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontFamily: "'Roboto', sans-serif",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                            }}
                          >
                            Lead generation with WhatsApp chats.
                          </Typography>
                        </Stack>

                        <Stack
                          sx={{
                            display: {
                              xs: "none", // Hide on extra small screens
                              sm: "none", // Hide on small screens
                              md: "flex", // Show on medium and larger screens
                              lg: "none",
                              xl: "flex",
                            },
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              display: {
                                xl: "flex",
                                lg: "flex",
                                md: "none",
                                sm: "flex",
                                xs: "flex",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                            }}
                          >
                            Enhance customer journey through WhatsApp.
                          </Typography>
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              display: {
                                xl: "none",
                                lg: "none",
                                md: "flex",
                                sm: "none",
                                xs: "none",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                            }}
                          >
                            Enhance journey through WhatsApp.
                          </Typography>
                        </Stack>
                      </Stack>
                    </Stack>
                    <Stack
                      sx={{
                        //border: "1px solid red",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        // paddingLeft: "40px",
                        paddingLeft: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "12px",
                          sm: "40px",
                        },
                        // paddingRight: {
                        //   lg: "40px",
                        //   xl: "40px",
                        //   md: "40px",
                        //   xs: "0px",
                        //   sm: "40px",
                        // },
                      }}
                    >
                      {/* <Button
                        variant="contained"
                        startIcon={<FaInfoCircle style={{ color: "white" }} />}
                        // sx={{
                        //   backgroundColor: "rgb(31,133,192)",
                        //   textTransform: "none",
                        //   borderRadius: "8px",
                        //   boxShadow:
                        //     "0 4px 8px rgba(0,0,0,0.2), 0 1px 3px rgba(0,0,0,0.1)",
                        // }}
                        // size="large"
                        sx={{
                          textTransform: "none",
                          borderRadius: "8px",
                          backgroundColor: "rgb(5, 78, 146)", // Initial background
                          color: "white", // Text color
                          borderColor: "rgb(5, 78, 146)", // Border same as background
                          boxShadow:
                            "0 4px 8px rgba(0,0,0,0.2), 0 1px 3px rgba(0,0,0,0.1)",

                          "&:hover": {
                            backgroundColor: "rgb(31, 133, 192)", // Hover background
                            borderColor: "rgb(31, 133, 192)", // Hover border
                          },
                        }}
                        size="large"
                        onClick={handleClick1}
                      >
                        Know more
                      </Button> */}
                    </Stack>
                  </Stack>
                </Stack>
              </Stack>
            </Box>
          </Grid>

          <Grid
            key={`grid-${1}`}
            component="li"
            sx={{
              boxSizing: "border-box",
              padding: "30px",
              borderRadius: "20px",
              height: "67vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "sticky",
              // top: 80 + 1 * 35, // Adjust top for each grid
              top: isSm ? 50 + 1 * 35 : 80 + 1 * 35,
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              // backgroundColor: "#f5e9e9",
              backdropFilter: "blur(8px)",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
              border: "1px solid rgba(255, 255, 255, 0.5)",
              transform: `scale(${scales[1] || 1})`, // Apply dynamic scaling
              transition: "transform 0.1s ease-in-out", // Smooth scaling animation
            }}
          >
            <Box
              sx={{
                backgroundColor: "white",
                width: "100%",
                height: "100%",
              }}
            >
              <Stack
                sx={{
                  width: "100%",
                  height: "100%",

                  display: {
                    lg: "flex",
                    xl: "flex",
                    sm: "flex",
                  },
                  flexDirection: {
                    lg: "row",
                    xl: "row",
                    md: "row",
                    sm: "column",
                  },
                  justifyContent: {
                    lg: "center",
                    xl: "center",
                    sm: "center",
                  },
                  alignItems: {
                    lg: "center",
                    xl: "center",
                    sm: "center",
                  },
                  gap: 2,
                  // background: "linear-gradient(to right, #cce7ff, #f4e3ff)", // Gradient background
                  //   background: "#FFE8EC",
                }}
              >
                <Stack
                  sx={{
                    //border: "1px solid green",
                    height: {
                      lg: "100%",
                      xl: "100%",
                      md: "100%",
                      xs: "180%",
                      sm: "50%",
                    },
                    width: {
                      lg: "60%",
                      xl: "60%",
                      md: "50%",
                      xs: "100%",
                      sm: "100%",
                    },

                    // borderRadius: "20px", // Rounded corners for a smooth look
                    backdropFilter: "blur(12px)", // Frosted glass effect
                    // backgroundColor: "rgba(255, 255, 255, 0.5)",
                    backgroundColor: "#F5EEED",
                    // boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)", // Soft shadow for depth
                    // border: "1px solid rgba(255, 255, 255, 0.2)", // Subtle border for separation
                    overflow: "hidden", // Ensure internal content doesn't overflow
                    position: "relative", // Needed for shine effect
                    display: "flex",
                    // alignItems: "center",
                    // justifyContent: "center",
                    transition: "all 0.5s ease-in-out",
                  }}
                >
                  <Stack
                    sx={{
                      height: "100%",
                      width: "100%",
                      // border: "2px solid green",
                      marginTop: {
                        lg: "0px",
                        xl: "0px",
                        md: "0px",
                        xs: "0px",
                        sm: "0px",
                      },
                    }}
                  >
                    <img
                      src={From}
                      alt="Image1"
                      style={{
                        height: "105%",
                        width: "100%",
                        // border: "1px solid red",
                      }}
                    />
                  </Stack>
                </Stack>

                <Stack
                  sx={{
                    backgroundColor: "white",
                    // border: "1px solid blue",
                    height: {
                      lg: "100%",
                      xl: "100%",
                      md: "100%",
                      xs: "50%",
                      sm: "50%",
                      //   xs: "auto",
                      //   sm: "auto",
                    },
                    width: {
                      lg: "40%",
                      xl: "40%",
                      md: "50%",
                      xs: "100%",
                      sm: "100%",
                    },
                    paddingTop: {
                      lg: "0px",
                      xl: "0px",
                      xs: "8px",
                      sm: "12px",
                    },
                  }}
                >
                  <Stack
                    sx={{
                      height: "100%",
                      marginTop: {
                        lg: "60px",
                        xl: "60px",
                        // md: "0px",
                        xs: "0px",
                        sm: "0px",
                      },
                    }}
                  >
                    <Stack
                      sx={{
                        // border: "1px solid red",
                        height: "auto",
                        // lineHeight: "48px",
                        lineHeight: {
                          lg: "32px",
                          xl: "40px",
                          md: "28px",
                          xs: "23px",
                          sm: "36px",
                        },
                        // fontSize: "39px",
                        fontSize: {
                          lg: "29px",
                          xl: "36px",
                          md: "24px",
                          xs: "18px",
                          sm: "28px",
                        },
                        fontWeight: "700",
                        color: "rgb(0, 0, 0)",
                        fontFamily: "'Roboto', sans-serif",
                        // paddingLeft: "40px",
                        // paddingRight: "40px",
                        paddingLeft: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "0px",
                          sm: "40px",
                        },
                        paddingRight: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "0px",
                          sm: "40px",
                        },
                        marginBottom: {
                          lg: "20px",
                          xl: "20px",
                          md: "20px",
                          xs: "8px",
                          sm: "8px",
                        },
                        display: "flex",
                        flexDirection: "row",
                        gap: 1,
                      }}
                    >
                      <Stack
                        sx={{
                          // border: "1px solid red",
                          height: { xl: "100%", lg: "100%", xs: "100%" },
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Stack
                          sx={{
                            width: { xl: "8px", lg: "8px", xs: "4px" },
                            height: {
                              xl: "89%",
                              lg: "94%",
                              md: "90%",
                              sm: "80%",
                              xs: "93%",
                            },
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            // border: "1px solid red",
                            backgroundColor: "rgb(5 78 146)",

                            borderTopRightRadius: "8px", // Adjust the value as needed
                            borderBottomRightRadius: "8px", // Adjust the value as needed
                          }}
                        >
                          <h4 style={{ color: "rgb(5 78 146)" }}>{""}</h4>
                        </Stack>
                      </Stack>
                      <span>
                        Interactive{" "}
                        <span style={{ color: "green" }}>WhatsApp forms</span>
                      </span>
                    </Stack>
                    <Stack
                      sx={{
                        height: "auto",
                        lineHeight: {
                          lg: "25px",
                          xl: "25px",
                          md: "32px",
                          xs: "20px",
                          sm: "32px",
                        },
                        // fontSize: "18px",
                        fontSize: {
                          lg: "20px",
                          xl: "20px",
                          md: "28px",
                          xs: "16px",
                          sm: "20px",
                        },
                        fontWeight: {
                          lg: "400",
                          xl: "400",
                          xs: "400",
                          sm: "400",
                        },
                        color: "rgb(0, 0, 0)",
                        // paddingLeft: "28px",
                        // paddingRight: "28px",
                        paddingLeft: {
                          lg: "28px",
                          xl: "28px",
                          md: "28px",
                          xs: "0px",
                          sm: "28px",
                        },
                        paddingRight: {
                          lg: "28px",
                          xl: "28px",
                          md: "28px",
                          xs: "0px",
                          sm: "28px",
                        },
                        fontFamily: "'Roboto', sans-serif",
                        // border: "1px solid blue",
                        marginBottom: {
                          lg: "20px",
                          xl: "20px",
                          md: "20px",
                          xs: "8px",
                          sm: "8px",
                        },
                      }}
                    >
                      <Stack
                        sx={{
                          height: "auto",
                          lineHeight: {
                            lg: "32px",
                            xl: "32px",
                            md: "24px",
                            xs: "24px",
                            sm: "32px",
                          },
                          // fontSize: "18px",
                          fontSize: {
                            lg: "20px",
                            xl: "20px",
                            md: "16px",
                            xs: "16px",
                            sm: "20px",
                          },
                          fontWeight: {
                            lg: "400",
                            xl: "400",
                            xs: "400",
                            sm: "400",
                          },
                          color: "rgb(0, 0, 0)",
                          // paddingLeft: "40px",
                          // paddingRight: "40px",
                          padding: "12px",
                          fontFamily: "'Roboto', sans-serif",
                          border: "1px solid rgb(235 229 243)",
                          backgroundColor: "#F5EEED",
                          borderRadius: "8px",
                        }}
                      >
                        Interactive WhatsApp forms streamline registrations,
                        appointments and applications with real-time
                        submissions.
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        height: "auto",
                        color: "rgb(73, 72, 72)",
                        // paddingLeft: "40px",
                        // paddingRight: "40px",
                        paddingLeft: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "12px",
                          sm: "40px",
                        },
                        paddingRight: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "12px",
                          sm: "40px",
                        },
                        // border: "1px solid red",
                      }}
                    >
                      <Stack>
                        <Stack
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          {/* <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                            }}
                          >
                            Easliy form filling reduce manual effort.
                          </Typography> */}
                        </Stack>
                        <Stack
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          {/* <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                            }}
                          >
                            Easily accessible forms on mobile.
                          </Typography> */}
                        </Stack>
                        <Stack
                          sx={{
                            display: {
                              xl: "flex",
                              lg: "flex",
                              md: "flex",
                              sm: "flex",
                              xs: "none",
                            },
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                            }}
                          >
                            Quickly submit details without hassle.
                          </Typography>
                        </Stack>

                        {/* <Stack
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                            }}
                          >
                            Fill forms directly within WhatsApp.
                          </Typography>
                        </Stack> */}

                        <Stack
                          sx={{
                            display: {
                              xs: "none", // Hide on extra small screens
                              sm: "none", // Hide on small screens
                              md: "flex", // Show on medium and larger screens
                              lg: "none",
                              xl: "flex",
                            },
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              // display: {
                              //   xs: "none", // Hide on extra small screens
                              //   sm: "none", // Hide on small screens
                              //   md: "flex", // Show on medium and larger screens
                              //   lg: "none",
                              //   xl: "flex",
                              // },
                            }}
                          >
                            Boost lead generation with real-time forms.
                          </Typography>
                          {/* <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              display: {
                                xs: "flex", // Hide on extra small screens
                                sm: "none", // Hide on small screens
                                md: "none", // Show on medium and larger screens
                                lg: "none",
                                xl: "none",
                              },
                            }}
                          >
                            Boost lead generation with real-time.
                          </Typography> */}
                        </Stack>

                        <Stack
                          sx={{
                            display: {
                              xs: "none", // Hide on extra small screens
                              sm: "none", // Hide on small screens
                              md: "flex", // Show on medium and larger screens
                              lg: "none",
                              xl: "flex",
                            },
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              // display: {
                              //   xs: "none", // Hide on extra small screens
                              //   sm: "none", // Hide on small screens
                              //   md: "flex", // Show on medium and larger screens
                              //   lg: "none",
                              //   xl: "flex",
                              // },
                            }}
                          >
                            Collect leads and customer data effortlessly.
                          </Typography>
                          {/* <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              display: {
                                xs: "none", // Hide on extra small screens
                                sm: "none", // Hide on small screens
                                md: "none", // Show on medium and larger screens
                                lg: "none",
                                xl: "none",
                              },
                            }}
                          >
                            Collect leads data effortlessly.
                          </Typography> */}
                        </Stack>
                      </Stack>
                    </Stack>
                    <Stack
                      sx={{
                        // border: "1px solid red",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        // paddingLeft: "40px",
                        paddingLeft: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "12px",
                          sm: "40px",
                        },
                      }}
                    >
                      {/* <Button
                        variant="contained"
                        startIcon={<FaInfoCircle style={{ color: "white" }} />}
                        // sx={{
                        //   backgroundColor: "rgb(31,133,192)",
                        //   textTransform: "none",
                        //   borderRadius: "8px",
                        //   boxShadow:
                        //     "0 4px 8px rgba(0,0,0,0.2), 0 1px 3px rgba(0,0,0,0.1)",
                        // }}
                        sx={{
                          textTransform: "none",
                          borderRadius: "8px",
                          backgroundColor: "rgb(5, 78, 146)", // Initial background
                          color: "white", // Text color
                          borderColor: "rgb(5, 78, 146)", // Border same as background
                          boxShadow:
                            "0 4px 8px rgba(0,0,0,0.2), 0 1px 3px rgba(0,0,0,0.1)",

                          "&:hover": {
                            backgroundColor: "rgb(31, 133, 192)", // Hover background
                            borderColor: "rgb(31, 133, 192)", // Hover border
                          },
                        }}
                        size="large"
                        onClick={handleClick2}
                      >
                        Know more
                      </Button> */}
                    </Stack>
                  </Stack>
                </Stack>
              </Stack>
            </Box>
          </Grid>

          <Grid
            key={`grid-${2}`}
            component="li"
            sx={{
              boxSizing: "border-box",
              padding: "30px",
              borderRadius: "20px",
              height: "67vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "sticky",
              // top: 80 + 2 * 35, // Adjust top for each grid
              top: isSm ? 50 + 2 * 35 : 80 + 2 * 35,
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              backdropFilter: "blur(8px)",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
              border: "1px solid rgba(255, 255, 255, 0.5)",
              transform: `scale(${scales[2] || 1})`, // Apply dynamic scaling
              transition: "transform 0.1s ease-in-out", // Smooth scaling animation
            }}
          >
            <Box
              sx={{
                backgroundColor: "white",
                width: "100%",
                height: "100%",
                // border: "1px solid red",
              }}
            >
              <Stack
                sx={{
                  width: "100%",
                  height: "100%",

                  display: {
                    lg: "flex",
                    xl: "flex",
                    sm: "flex",
                  },
                  flexDirection: {
                    lg: "row",
                    xl: "row",
                    md: "row",
                    sm: "column",
                  },
                  justifyContent: {
                    lg: "center",
                    xl: "center",
                    sm: "center",
                  },
                  alignItems: {
                    lg: "center",
                    xl: "center",
                    sm: "center",
                  },
                  // background: "linear-gradient(to right, #cce7ff, #f4e3ff)", // Gradient background
                  //   background: "#E1E5FF", // Gradient background
                  gap: 2,
                }}
              >
                <Stack
                  sx={{
                    // border: "1px solid green",
                    height: {
                      lg: "100%",
                      xl: "100%",
                      md: "100%",
                      xs: "180%",
                      sm: "50%",
                    },
                    width: {
                      lg: "60%",
                      xl: "60%",
                      md: "50%",
                      xs: "100%",
                      sm: "100%",
                    },

                    // borderRadius: "20px", // Rounded corners for a smooth look
                    backdropFilter: "blur(12px)", // Frosted glass effect
                    // backgroundColor: "rgba(255, 255, 255, 0.5)",
                    backgroundColor: "rgb(232 242 254)",
                    // boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)", // Soft shadow for depth
                    // border: "1px solid rgba(255, 255, 255, 0.2)", // Subtle border for separation
                    overflow: "hidden", // Ensure internal content doesn't overflow
                    position: "relative", // Needed for shine effect
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "all 0.5s ease-in-out",
                  }}
                >
                  <Stack
                    sx={{
                      height: "100%",
                      width: "100%",
                      //   border: "1px solid green",
                      marginTop: {
                        lg: "0px",
                        xl: "0px",
                        md: "0px",
                        xs: "0px",
                        sm: "0px",
                      },
                    }}
                  >
                    <img
                      src={Template}
                      alt="Image1"
                      style={{
                        height: "105%",
                        width: "100%",
                      }}
                    />
                  </Stack>
                </Stack>

                <Stack
                  sx={{
                    backgroundColor: "white",
                    // border: "1px solid blue",
                    height: {
                      lg: "100%",
                      xl: "100%",
                      md: "100%",
                      xs: "50%",
                      sm: "50%",
                      //   xs: "auto",
                      //   sm: "auto",
                    },
                    width: {
                      lg: "40%",
                      xl: "40%",
                      md: "50%",
                      xs: "100%",
                      sm: "100%",
                    },

                    paddingTop: {
                      lg: "0px",
                      xl: "0px",
                      xs: "8px",
                      sm: "12px",
                    },
                  }}
                >
                  <Stack
                    sx={{
                      height: "100%",
                      marginTop: {
                        lg: "60px",
                        xl: "60px",
                        // md: "0px",
                        xs: "0px",
                        sm: "0px",
                      },
                    }}
                  >
                    <Stack
                      sx={{
                        // border: "1px solid red",
                        height: "auto",
                        // lineHeight: "48px",
                        lineHeight: {
                          lg: "32px",
                          xl: "40px",
                          md: "32px",
                          xs: "23px",
                          sm: "36px",
                        },
                        // fontSize: "39px",
                        fontSize: {
                          lg: "29px",
                          xl: "36px",
                          md: "24px",
                          xs: "18px",
                          sm: "28px",
                        },
                        fontWeight: "700",
                        color: "rgb(0, 0, 0)",
                        // paddingLeft: "40px",
                        // paddingRight: "40px",
                        paddingLeft: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "0px",
                          sm: "40px",
                        },
                        paddingRight: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "0px",
                          sm: "40px",
                        },
                        fontFamily: "'Roboto', sans-serif",
                        marginBottom: {
                          lg: "20px",
                          xl: "20px",
                          md: "20px",
                          xs: "8px",
                          sm: "8px",
                        },
                        display: "flex",
                        flexDirection: "row",
                        gap: 1,
                      }}
                    >
                      <Stack
                        sx={{
                          // border: "1px solid red",
                          height: { xl: "100%", lg: "100%", xs: "100%" },
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Stack
                          sx={{
                            width: { xl: "8px", lg: "8px", xs: "4px" },
                            height: {
                              xl: "89%",
                              lg: "94%",
                              md: "90%",
                              sm: "80%",
                              xs: "93%",
                            },
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            // border: "1px solid red",
                            backgroundColor: "rgb(5 78 146)",

                            borderTopRightRadius: "8px", // Adjust the value as needed
                            borderBottomRightRadius: "8px", // Adjust the value as needed
                          }}
                        >
                          <h4 style={{ color: "rgb(5 78 146)" }}>{""}</h4>
                        </Stack>
                      </Stack>
                      <span>
                        {" "}
                        Simplify chats using{" "}
                        <span style={{ color: "green" }}>templates</span>
                      </span>
                    </Stack>
                    <Stack
                      sx={{
                        height: "auto",
                        lineHeight: {
                          lg: "25px",
                          xl: "25px",
                          md: "24px",
                          xs: "20px",
                          sm: "32px",
                        },
                        // fontSize: "18px",
                        fontSize: {
                          lg: "20px",
                          xl: "20px",
                          md: "20px",
                          xs: "16px",
                          sm: "20px",
                        },
                        fontWeight: {
                          lg: "400",
                          xl: "400",
                          xs: "400",
                          sm: "400",
                        },
                        color: "rgb(0, 0, 0)",
                        // paddingLeft: "28px",
                        // paddingRight: "28px",
                        paddingLeft: {
                          lg: "28px",
                          xl: "28px",
                          md: "28px",
                          xs: "0px",
                          sm: "28px",
                        },
                        paddingRight: {
                          lg: "28px",
                          xl: "28px",
                          md: "28px",
                          xs: "0px",
                          sm: "28px",
                        },
                        // border: "1px solid blue",
                        fontFamily: "'Roboto', sans-serif",
                        marginBottom: {
                          lg: "20px",
                          xl: "20px",
                          md: "12px",
                          xs: "8px",
                          sm: "8px",
                        },
                      }}
                    >
                      <Stack
                        sx={{
                          height: "auto",
                          lineHeight: {
                            lg: "32px",
                            xl: "32px",
                            md: "24px",
                            xs: "24px",
                            sm: "32px",
                          },
                          // fontSize: "18px",
                          fontSize: {
                            lg: "20px",
                            xl: "20px",
                            md: "16px",
                            xs: "16px",
                            sm: "20px",
                          },
                          fontWeight: {
                            lg: "400",
                            xl: "400",
                            xs: "400",
                            sm: "400",
                          },
                          color: "rgb(0, 0, 0)",
                          // paddingLeft: "40px",
                          padding: "12px",
                          // paddingRight: "40px",
                          border: "1px solid rgb(232 242 254)",
                          backgroundColor: "rgb(232 242 254)",
                          borderRadius: "8px",
                          fontFamily: "'Roboto', sans-serif",
                        }}
                      >
                        Boost interaction speed with pre-approved customized
                        WhatsApp templates for delivering instant updates, notifications and 
                        reminders.
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        height: "auto",
                        color: "rgb(73, 72, 72)",
                        // paddingLeft: "40px",
                        // paddingRight: "40px",
                        paddingLeft: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "12px",
                          sm: "40px",
                        },
                        paddingRight: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "12px",
                          sm: "40px",
                        },
                        // border: "1px solid red",
                      }}
                    >
                      <Stack>
                        <Stack
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          {/* <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "} */}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              display: {
                                xl: "flex",
                                lg: "flex",
                                md: "none",
                                sm: "flex",
                                xs: "none",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                            }}
                          >
                            Showcase multiple products via carousel messages.
                          </Typography>
                          {/* <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              display: {
                                xl: "none",
                                lg: "none",
                                md: "flex",
                                sm: "none",
                                xs: "flex",
                              },

                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                            }}
                          >
                            Products via carousel messages.
                          </Typography> */}
                        </Stack>
                        <Stack
                          sx={{
                            display: {
                              xl: "flex",
                              lg: "flex",
                              md: "none",
                              sm: "flex",
                              xs: "none",
                            },
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },

                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              display: {
                                xl: "flex",
                                lg: "flex",
                                md: "flex",
                                sm: "flex",
                                xs: "none",
                              },
                            }}
                          >
                            Highlight limited-time offers with call-to-actions
                            button.
                          </Typography>
                        </Stack>
                        <Stack
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          {/* <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                            }}
                          >
                            Share catalog for easy browsing.
                          </Typography> */}
                        </Stack>

                        <Stack
                          sx={{
                            display: {
                              xl: "flex",
                              lg: "flex",
                              md: "flex",
                              sm: "flex",
                              xs: "none",
                            },
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                            }}
                          >
                            Send checkout reminders for abandoned carts.
                          </Typography>
                        </Stack>

                        {/* <Stack
                          sx={{
                            // display: {
                            //   xs: "none", // Hide on extra small screens
                            //   sm: "none", // Hide on small screens
                            //   md: "flex", // Show on medium and larger screens
                            //   lg: "none",
                            //   xl: "flex",
                            // },
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              display: {
                                xl: "flex",
                                lg: "flex",
                                md: "none",
                                sm: "flex",
                                xs: "none",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                            }}
                          >
                            Deliver exclusive discount coupons to customers.
                          </Typography>
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              display: {
                                xl: "none",
                                lg: "none",
                                md: "flex",
                                sm: "none",
                                xs: "none",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },

                              display: {
                                xl: "none",
                                lg: "none",
                                md: "none",
                                sm: "none",
                                xs: "flex",
                              },
                            }}
                          >
                            Deliver discount coupons to customers.
                          </Typography>
                        </Stack> */}

                        <Stack
                          sx={{
                            display: {
                              xs: "none", // Hide on extra small screens
                              sm: "flex", // Hide on small screens
                              md: "flex", // Show on medium and larger screens
                              lg: "flex",
                              xl: "flex",
                            },
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              display: {
                                xl: "flex",
                                lg: "flex",
                                md: "none",
                                sm: "flex",
                                xs: "none",
                              },
                            }}
                          >
                            Send single-product messages for specific
                            promotions.
                          </Typography>
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              display: {
                                xl: "none",
                                lg: "none",
                                md: "flex",
                                sm: "none",
                                xs: "none",
                              },
                            }}
                          >
                            Send product messages for promotions.
                          </Typography>
                        </Stack>
                      </Stack>
                    </Stack>
                    <Stack
                      sx={{
                        // border: "1px solid red",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        // paddingLeft: "40px",
                        paddingLeft: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "12px",
                          sm: "40px",
                        },
                      }}
                    >
                      {/* <Button
                        variant="contained"
                        startIcon={<FaInfoCircle style={{ color: "white" }} />}
                        // sx={{
                        //   backgroundColor: "rgb(31,133,192)",
                        //   textTransform: "none",
                        //   borderRadius: "8px",
                        //   boxShadow:
                        //     "0 4px 8px rgba(0,0,0,0.2), 0 1px 3px rgba(0,0,0,0.1)",
                        // }}
                        sx={{
                          textTransform: "none",
                          borderRadius: "8px",
                          backgroundColor: "rgb(5, 78, 146)", // Initial background
                          color: "white", // Text color
                          borderColor: "rgb(5, 78, 146)", // Border same as background
                          boxShadow:
                            "0 4px 8px rgba(0,0,0,0.2), 0 1px 3px rgba(0,0,0,0.1)",

                          "&:hover": {
                            backgroundColor: "rgb(31, 133, 192)", // Hover background
                            borderColor: "rgb(31, 133, 192)", // Hover border
                          },
                        }}
                        size="large"
                        onClick={handleClick3}
                      >
                        Know more
                      </Button> */}
                    </Stack>
                  </Stack>
                </Stack>
                {/* images */}
              </Stack>
            </Box>
          </Grid>

          <Grid
            key={`grid-${3}`}
            component="li"
            sx={{
              boxSizing: "border-box",
              padding: "30px",
              borderRadius: "20px",
              height: "67vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "sticky",
              // top: 80 + 3 * 35, // Adjust top for each grid
              top: isSm ? 50 + 3 * 35 : 80 + 3 * 35,
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              backdropFilter: "blur(8px)",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
              border: "1px solid rgba(255, 255, 255, 0.5)",
              transform: `scale(${scales[3] || 1})`, // Apply dynamic scaling
              transition: "transform 0.1s ease-in-out", // Smooth scaling animation
            }}
          >
            <Box
              sx={{
                backgroundColor: "white",
                width: "100%",
                height: "100%",
                // border: "1px solid red",
              }}
            >
              <Stack
                sx={{
                  width: "100%",
                  height: "100%",

                  display: {
                    lg: "flex",
                    xl: "flex",
                    sm: "flex",
                  },
                  flexDirection: {
                    lg: "row",
                    xl: "row",
                    md: "row",
                    sm: "column",
                  },
                  justifyContent: {
                    lg: "center",
                    xl: "center",
                    sm: "center",
                  },
                  alignItems: {
                    lg: "center",
                    xl: "center",
                    sm: "center",
                  },
                  // background: "linear-gradient(to right, #cce7ff, #f4e3ff)", // Gradient background
                  //   background: "#D9FAFF", // Gradient background
                  gap: 2,
                }}
              >
                <Stack
                  sx={{
                    // border: "1px solid green",
                    height: {
                      lg: "100%",
                      xl: "100%",
                      md: "100%",
                      xs: "180%",
                      sm: "50%",
                    },
                    width: {
                      lg: "60%",
                      xl: "60%",
                      md: "50%",
                      xs: "100%",
                      sm: "100%",
                    },

                    // borderRadius: "20px", // Rounded corners for a smooth look
                    backdropFilter: "blur(12px)", // Frosted glass effect
                    // backgroundColor: "rgba(255, 255, 255, 0.5)",
                    backgroundColor: "rgb(224 240 241)",
                    // boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)", // Soft shadow for depth
                    // border: "1px solid rgba(255, 255, 255, 0.2)", // Subtle border for separation
                    overflow: "hidden", // Ensure internal content doesn't overflow
                    position: "relative", // Needed for shine effect
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "all 0.5s ease-in-out",

                    // Shine Effect
                    // "&::before": {
                    //   content: '""',
                    //   position: "absolute",
                    //   top: 0,
                    //   left: 0,
                    //   width: "100%",
                    //   height: "100%",
                    //   background:
                    //     "linear-gradient(45deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 0.2) 100%)",
                    //   opacity: 0.6, // Adjust opacity for subtle or prominent shine
                    //   transform: "translate(-100%, -100%)",
                    //   animation: "shineEffect 3s infinite linear",
                    // },
                    // "@keyframes shineEffect": {
                    //   "0%": {
                    //     transform: "translate(-100%, -100%)",
                    //   },
                    //   "100%": {
                    //     transform: "translate(100%, 100%)",
                    //   },
                    // },
                  }}
                >
                  <Stack
                    sx={{
                      height: "100%",
                      width: "100%",
                      //   border: "1px solid green",
                      marginTop: {
                        lg: "0px",
                        xl: "0px",
                        md: "0px",
                        xs: "0px",
                        sm: "0px",
                      },
                    }}
                  >
                    <img
                      src={Intergration}
                      alt="Image1"
                      style={{
                        height: "105%",
                        width: "100%",
                      }}
                    />
                  </Stack>
                </Stack>

                <Stack
                  sx={{
                    backgroundColor: "white",
                    // border: "1px solid blue",
                    height: {
                      lg: "100%",
                      xl: "100%",
                      md: "100%",
                      xs: "50%",
                      sm: "50%",
                      //   xs: "auto",
                      //   sm: "auto",
                    },
                    width: {
                      lg: "40%",
                      xl: "40%",
                      md: "50%",
                      xs: "100%",
                      sm: "100%",
                    },

                    paddingTop: {
                      lg: "0px",
                      xl: "0px",
                      xs: "8px",
                      sm: "12px",
                    },
                  }}
                >
                  <Stack
                    sx={{
                      height: "100%",
                      marginTop: {
                        lg: "60px",
                        xl: "60px",
                        // md: "0px",
                        xs: "0px",
                        sm: "0px",
                      },
                    }}
                  >
                    <Stack
                      sx={{
                        // border: "1px solid red",
                        height: "auto",
                        // lineHeight: "48px",
                        lineHeight: {
                          lg: "32px",
                          xl: "40px",
                          md: "32px",
                          xs: "23px",
                          sm: "36px",
                        },
                        // fontSize: "39px",
                        fontSize: {
                          lg: "29px",
                          xl: "36px",
                          md: "24px",
                          xs: "18px",
                          sm: "28px",
                        },
                        fontWeight: "700",
                        color: "rgb(0, 0, 0)",
                        // paddingLeft: "28px",
                        // paddingRight: "28px",
                        paddingLeft: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "0px",
                          sm: "40px",
                        },
                        paddingRight: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "0px",
                          sm: "40px",
                        },
                        fontFamily: "'Roboto', sans-serif",
                        marginBottom: {
                          lg: "20px",
                          xl: "20px",
                          md: "12px",
                          xs: "8px",
                          sm: "8px",
                        },
                        display: "flex",
                        flexDirection: "row",
                        gap: 1,
                      }}
                    >
                      <Stack
                        sx={{
                          // border: "1px solid red",
                          height: { xl: "100%", lg: "100%", xs: "100%" },
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Stack
                          sx={{
                            width: { xl: "8px", lg: "8px", xs: "4px" },
                            height: {
                              xl: "89%",
                              lg: "94%",
                              md: "90%",
                              sm: "80%",
                              xs: "93%",
                            },
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            // border: "1px solid red",
                            backgroundColor: "rgb(5 78 146)",

                            borderTopRightRadius: "8px", // Adjust the value as needed
                            borderBottomRightRadius: "8px", // Adjust the value as needed
                          }}
                        >
                          <h4 style={{ color: "rgb(5 78 146)" }}>{""}</h4>
                        </Stack>
                      </Stack>
                      <Stack
                        sx={{
                          display: {
                            xl: "flex",
                            lg: "flex",
                            md: "flex",
                            sm: "flex",
                            xs: "none",
                          },
                        }}
                      >
                        <span>
                          {" "}
                          <span style={{ color: "green" }}>
                            Payment integration
                          </span>{" "}
                          for WhatsApp
                        </span>
                      </Stack>

                      <Stack
                        sx={{
                          display: {
                            xl: "none",
                            lg: "none",
                            md: "none",
                            sm: "none",
                            xs: "flex",
                          },
                        }}
                      >
                        <span>
                          {" "}
                          <span style={{ color: "green" }}>WhatsApp</span>{" "}
                          payment
                        </span>
                      </Stack>
                    </Stack>
                    <Stack
                      sx={{
                        height: "auto",
                        lineHeight: {
                          lg: "25px",
                          xl: "25px",
                          md: "32px",
                          xs: "20px",
                          sm: "28px",
                        },
                        // fontSize: "18px",
                        fontSize: {
                          lg: "20px",
                          xl: "20px",
                          md: "28px",
                          xs: "16px",
                          sm: "20px",
                        },
                        fontWeight: {
                          lg: "400",
                          xl: "400",
                          xs: "400",
                          sm: "400",
                        },
                        color: "rgb(0, 0, 0)",
                        // paddingLeft: "40px",
                        // paddingRight: "40px",
                        paddingLeft: {
                          lg: "28px",
                          xl: "28px",
                          md: "28px",
                          xs: "0px",
                          sm: "28px",
                        },
                        paddingRight: {
                          lg: "28px",
                          xl: "28px",
                          md: "28px",
                          xs: "0px",
                          sm: "28px",
                        },
                        // border: "1px solid blue",
                        fontFamily: "'Roboto', sans-serif",
                        marginBottom: {
                          lg: "20px",
                          xl: "20px",
                          md: "12px",
                          xs: "8px",
                          sm: "8px",
                        },
                      }}
                    >
                      <Stack
                        sx={{
                          height: "auto",
                          lineHeight: {
                            lg: "32px",
                            xl: "32px",
                            md: "24px",
                            xs: "24px",
                            sm: "28px",
                          },
                          // fontSize: "18px",
                          fontSize: {
                            lg: "20px",
                            xl: "20px",
                            md: "16px",
                            xs: "16px",
                            sm: "20px",
                          },
                          fontWeight: {
                            lg: "400",
                            xl: "400",
                            xs: "400",
                            sm: "400",
                          },
                          color: "rgb(0, 0, 0)",
                          // paddingLeft: "40px",
                          // paddingRight: "40px",
                          padding: "12px",
                          border: "1px solid rgb(224 240 241)",
                          backgroundColor: "rgb(224 240 241)",
                          borderRadius: "8px",
                          fontFamily: "'Roboto', sans-serif",
                        }}
                      >
                        Accept payments instantly via WhatsApp using shared
                        links, delivering a smooth, effortless and secure
                        checkout experience for your customers.
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        height: "auto",
                        color: "rgb(73, 72, 72)",
                        // paddingLeft: "40px",
                        // paddingRight: "40px",
                        paddingLeft: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "12px",
                          sm: "40px",
                        },
                        paddingRight: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "12px",
                          sm: "40px",
                        },
                        // border: "1px solid red",
                      }}
                    >
                      <Stack>
                        <Stack
                          sx={{
                            display: {
                              xs: "none", // Hide on extra small screens
                              sm: "flex", // Hide on small screens
                              md: "flex", // Show on medium and larger screens
                              lg: "flex",
                              xl: "flex",
                            },
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                            }}
                          >
                            Enable seamless in - chat payment experience.
                          </Typography>
                        </Stack>
                        <Stack
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          {/* <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                            }}
                          >
                            Offer multiple payment modes to users.
                          </Typography> */}
                        </Stack>
                        <Stack
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          {/* <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "} */}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              display: {
                                xs: "none", // Hide on extra small screens
                                sm: "flex", // Hide on small screens
                                md: "flex", // Show on medium and larger screens
                                lg: "flex",
                                xl: "flex",
                              },
                            }}
                          >
                            Send instant alerts after payment completion.
                          </Typography>
                          {/* <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              display: {
                                xs: "flex", // Hide on extra small screens
                                sm: "none", // Hide on small screens
                                md: "none", // Show on medium and larger screens
                                lg: "none",
                                xl: "none",
                              },
                            }}
                          >
                            Send alerts after payment completion.
                          </Typography> */}
                        </Stack>
                        {/* <Stack
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "20px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "34px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "24px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                            }}
                          >
                            Simplify transactions with secure links.
                          </Typography>
                        </Stack> */}

                        <Stack
                          sx={{
                            display: {
                              xs: "none", // Hide on extra small screens
                              sm: "none", // Hide on small screens
                              md: "flex", // Show on medium and larger screens
                              lg: "none",
                              xl: "flex",
                            },
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              display: {
                                xs: "none", // Hide on extra small screens
                                sm: "none", // Hide on small screens
                                md: "flex", // Show on medium and larger screens
                                lg: "none",
                                xl: "flex",
                              },
                            }}
                          >
                            Ensure secure UPI payment gateway integration.
                          </Typography>
                          {/* <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },

                              display: {
                                xs: "flex", // Hide on extra small screens
                                sm: "none", // Hide on small screens
                                md: "none", // Show on medium and larger screens
                                lg: "none",
                                xl: "none",
                              },
                            }}
                          >
                            Secure UPI payment gateway integration.
                          </Typography> */}
                        </Stack>

                        {/* <Stack
                          sx={{
                            // display: {
                            //   xs: "none", // Hide on extra small screens
                            //   sm: "none", // Hide on small screens
                            //   md: "flex", // Show on medium and larger screens
                            //   lg: "none",
                            //   xl: "flex",
                            // },
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              display: {
                                xs: "none", // Hide on extra small screens
                                sm: "none", // Hide on small screens
                                md: "flex", // Show on medium and larger screens
                                lg: "none",
                                xl: "flex",
                              },
                            }}
                          >
                            Provide detailed order summary with invoice.
                          </Typography>
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              display: {
                                xs: "flex", // Hide on extra small screens
                                sm: "none", // Hide on small screens
                                md: "none", // Show on medium and larger screens
                                lg: "none",
                                xl: "none",
                              },
                            }}
                          >
                            Provide order summary with invoice.
                          </Typography>
                        </Stack> */}

                        <Stack
                          sx={{
                            display: {
                              xs: "none", // Hide on extra small screens
                              sm: "none", // Hide on small screens
                              md: "flex", // Show on medium and larger screens
                              lg: "none",
                              xl: "flex",
                            },
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              display: {
                                xs: "none", // Hide on extra small screens
                                sm: "none", // Hide on small screens
                                md: "flex", // Show on medium and larger screens
                                lg: "none",
                                xl: "flex",
                              },
                            }}
                          >
                            Allow checkout without page redirection.
                          </Typography>
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              display: {
                                xs: "none", // Hide on extra small screens
                                sm: "none", // Hide on small screens
                                md: "none", // Show on medium and larger screens
                                lg: "none",
                                xl: "none",
                              },
                            }}
                          >
                            Allow checkout without page redirection.
                          </Typography>
                        </Stack>
                      </Stack>
                    </Stack>
                    <Stack
                      sx={{
                        // border: "1px solid red",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        // paddingLeft: "40px",
                        paddingLeft: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "12px",
                          sm: "40px",
                        },
                      }}
                    >
                      {/* <Button
                        variant="contained"
                        startIcon={<FaInfoCircle style={{ color: "white" }} />}
                        // sx={{
                        //   backgroundColor: "rgb(31,133,192)",
                        //   textTransform: "none",
                        //   borderRadius: "8px",
                        //   boxShadow:
                        //     "0 4px 8px rgba(0,0,0,0.2), 0 1px 3px rgba(0,0,0,0.1)",
                        // }}
                        sx={{
                          textTransform: "none",
                          borderRadius: "8px",
                          backgroundColor: "rgb(5, 78, 146)", // Initial background
                          color: "white", // Text color
                          borderColor: "rgb(5, 78, 146)", // Border same as background
                          boxShadow:
                            "0 4px 8px rgba(0,0,0,0.2), 0 1px 3px rgba(0,0,0,0.1)",

                          "&:hover": {
                            backgroundColor: "rgb(31, 133, 192)", // Hover background
                            borderColor: "rgb(31, 133, 192)", // Hover border
                          },
                        }}
                        size="large"
                        onClick={handleClick4}
                      >
                        Know more
                      </Button> */}
                    </Stack>
                  </Stack>
                </Stack>
                {/* image */}
              </Stack>
            </Box>
          </Grid>

          <Grid
            key={`grid-${4}`}
            component="li"
            sx={{
              boxSizing: "border-box",
              padding: "30px",
              borderRadius: "20px",
              height: "67vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "sticky",
              // top: 80 + 4 * 35, // Adjust top for each grid
              top: isSm ? 50 + 4 * 35 : 80 + 4 * 35,
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              backdropFilter: "blur(8px)",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
              border: "1px solid rgba(255, 255, 255, 0.5)",
              transform: `scale(${scales[4] || 1})`, // Apply dynamic scaling
              transition: "transform 0.1s ease-in-out", // Smooth scaling animation
            }}
          >
            <Box
              sx={{
                backgroundColor: "white",
                width: "100%",
                height: "100%",
                // border: { md: "1px solid red", sm: "2px solid green" },
              }}
            >
              <Stack
                sx={{
                  width: "100%",
                  height: "100%",

                  display: {
                    lg: "flex",
                    xl: "flex",
                    sm: "flex",
                  },
                  flexDirection: {
                    lg: "row",
                    xl: "row",
                    md: "row",
                    sm: "column",
                  },
                  justifyContent: {
                    lg: "center",
                    xl: "center",
                    sm: "center",
                  },
                  alignItems: {
                    lg: "center",
                    xl: "center",
                    sm: "center",
                  },
                  // background: "linear-gradient(to right, #cce7ff, #f4e3ff)", // Gradient background
                  //   background: "#FFE0E0",
                  gap: 2,
                }}
              >
                <Stack
                  sx={{
                    // border: "1px solid green",
                    height: {
                      lg: "100%",
                      xl: "100%",
                      md: "100%",
                      xs: "180%",
                      sm: "50%",
                    },
                    width: {
                      lg: "60%",
                      xl: "60%",
                      md: "50%",
                      xs: "100%",
                      sm: "100%",
                    },

                    // borderRadius: "20px", // Rounded corners for a smooth look
                    backdropFilter: "blur(12px)", // Frosted glass effect
                    // backgroundColor: "rgba(255, 255, 255, 0.5)",
                    backgroundColor: "rgb(234 239 235)",
                    // boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)", // Soft shadow for depth
                    // border: "1px solid rgba(255, 255, 255, 0.2)", // Subtle border for separation
                    overflow: "hidden", // Ensure internal content doesn't overflow
                    position: "relative", // Needed for shine effect
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "all 0.5s ease-in-out",

                    // Shine Effect
                    // "&::before": {
                    //   content: '""',
                    //   position: "absolute",
                    //   top: 0,
                    //   left: 0,
                    //   width: "100%",
                    //   height: "100%",
                    //   background:
                    //     "linear-gradient(45deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 0.2) 100%)",
                    //   opacity: 0.6, // Adjust opacity for subtle or prominent shine
                    //   transform: "translate(-100%, -100%)",
                    //   animation: "shineEffect 3s infinite linear",
                    // },
                    // "@keyframes shineEffect": {
                    //   "0%": {
                    //     transform: "translate(-100%, -100%)",
                    //   },
                    //   "100%": {
                    //     transform: "translate(100%, 100%)",
                    //   },
                    // },
                  }}
                >
                  <Stack
                    sx={{
                      height: "100%",
                      width: "100%",
                      //   border: "1px solid green",
                      marginTop: {
                        lg: "0px",
                        xl: "0px",
                        md: "0px",
                        xs: "0px",
                        sm: "0px",
                      },
                    }}
                  >
                    <img
                      src={Webview}
                      alt="Image1"
                      style={{
                        height: "105%",
                        width: "100%",
                      }}
                    />
                  </Stack>
                </Stack>

                <Stack
                  sx={{
                    backgroundColor: "white",
                    // border: "1px solid blue",
                    height: {
                      lg: "100%",
                      xl: "100%",
                      md: "100%",
                      xs: "50%",
                      sm: "50%",
                      //   xs: "auto",
                      //   sm: "auto",
                    },
                    width: {
                      lg: "40%",
                      xl: "40%",
                      md: "50%",
                      xs: "100%",
                      sm: "100%",
                    },

                    paddingTop: {
                      lg: "0px",
                      xl: "0px",
                      xs: "8px",
                      sm: "12px",
                    },
                  }}
                >
                  <Stack
                    sx={{
                      height: "100%",
                      marginTop: {
                        lg: "60px",
                        xl: "60px",
                        // md: "0px",
                        xs: "0px",
                        sm: "0px",
                      },
                    }}
                  >
                    <Stack
                      sx={{
                        // border: "1px solid red",
                        height: "auto",
                        // lineHeight: "48px",
                        lineHeight: {
                          lg: "32px",
                          xl: "40px",
                          md: "32px",
                          xs: "23px",
                          sm: "36px",
                        },
                        // fontSize: "39px",
                        fontSize: {
                          lg: "29px",
                          xl: "36px",
                          md: "24px",
                          xs: "18px",
                          sm: "28px",
                        },
                        fontWeight: "700",
                        color: "rgb(0, 0, 0)",
                        // paddingLeft: "40px",
                        // paddingRight: "40px",
                        paddingLeft: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "0px",
                          sm: "40px",
                        },
                        paddingRight: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "0px",
                          sm: "40px",
                        },

                        marginBottom: {
                          lg: "20px",
                          xl: "20px",
                          md: "20px",
                          xs: "8px",
                          sm: "8px",
                        },
                        fontFamily: "'Roboto', sans-serif",
                        display: "flex",
                        flexDirection: "row",
                        gap: 1,
                      }}
                    >
                      <Stack
                        sx={{
                          // border: "1px solid red",
                          height: { xl: "100%", lg: "100%", xs: "100%" },
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Stack
                          sx={{
                            width: { xl: "8px", lg: "8px", xs: "4px" },
                            height: {
                              xl: "89%",
                              lg: "94%",
                              md: "90%",
                              sm: "80%",
                              xs: "93%",
                            },
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            // border: "1px solid red",
                            backgroundColor: "rgb(5 78 146)",

                            borderTopRightRadius: "8px", // Adjust the value as needed
                            borderBottomRightRadius: "8px", // Adjust the value as needed
                          }}
                        >
                          <h4 style={{ color: "rgb(5 78 146)" }}>{""}</h4>
                        </Stack>
                      </Stack>
                      <Stack>
                        {" "}
                        <span>
                          {" "}
                          In - chat{" "}
                          <span style={{ color: "green" }}>webview</span> on
                          WhatsApp
                        </span>
                      </Stack>
                    </Stack>
                    <Stack
                      sx={{
                        height: "auto",
                        lineHeight: {
                          lg: "32px",
                          xl: "32px",
                          md: "32px",
                          xs: "20px",
                          sm: "32px",
                        },
                        // fontSize: "18px",
                        fontSize: {
                          lg: "20px",
                          xl: "20px",
                          md: "28px",
                          xs: "16px",
                          sm: "20px",
                        },
                        fontWeight: {
                          lg: "400",
                          xl: "400",
                          xs: "400",
                          sm: "400",
                        },
                        color: "rgb(0, 0, 0)",
                        // paddingLeft: "28px",
                        // paddingRight: "28px",
                        paddingLeft: {
                          lg: "28px",
                          xl: "28px",
                          md: "28px",
                          xs: "0px",
                          sm: "28px",
                        },
                        paddingRight: {
                          lg: "28px",
                          xl: "28px",
                          md: "28px",
                          xs: "0px",
                          sm: "28px",
                        },
                        // border: "1px solid blue",
                        marginBottom: {
                          lg: "20px",
                          xl: "20px",
                          md: "20px",
                          xs: "8px",
                          sm: "8px",
                        },
                        fontFamily: "'Roboto', sans-serif",
                      }}
                    >
                      <Stack
                        sx={{
                          height: "auto",
                          lineHeight: {
                            lg: "25px",
                            xl: "25px",
                            md: "24px",
                            xs: "24px",
                            sm: "32px",
                          },
                          // fontSize: "18px",
                          fontSize: {
                            lg: "20px",
                            xl: "20px",
                            md: "16px",
                            xs: "16px",
                            sm: "20px",
                          },
                          fontWeight: {
                            lg: "400",
                            xl: "400",
                            xs: "400",
                            sm: "400",
                          },
                          color: "rgb(0, 0, 0)",
                          // paddingLeft: "40px",
                          // paddingRight: "40px",
                          borderRadius: "8px",
                          padding: "12px",
                          // border: "1px solid blue",
                          border: "1px solid rgb(234 239 235)",
                          backgroundColor: "rgb(234 239 235)",

                          fontFamily: "'Roboto', sans-serif",
                        }}
                      >
                        Let users browse your website or forms directly inside
                        WhatsApp without leaving the chat, using in-chat
                        webviews for a seamless experience.
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        height: "auto",
                        color: "rgb(73, 72, 72)",
                        // paddingLeft: "40px",
                        // paddingRight: "40px",
                        paddingLeft: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "12px",
                          sm: "40px",
                        },
                        paddingRight: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "12px",
                          sm: "40px",
                        },
                        // border: "1px solid red",
                      }}
                    >
                      <Stack>
                        <Stack
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          {/* <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              fontFamily: "'Roboto', sans-serif",
                            }}
                          >
                            Access web pages in WhatsApp.
                          </Typography> */}
                        </Stack>
                        <Stack
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          {/* <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "} */}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },

                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              display: {
                                xl: "flex",
                                lg: "flex",
                                md: "none",
                                sm: "flex",
                                xs: "none",
                              },
                            }}
                          >
                            Avoid redirects to browsers, reducing drop-offs.
                          </Typography>
                          {/* <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },

                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              display: {
                                xl: "none",
                                lg: "none",
                                md: "flex",
                                sm: "none",
                                xs: "flex",
                              },
                            }}
                          >
                            Avoid redirects to browsers.
                          </Typography> */}
                        </Stack>
                        <Stack
                          sx={{
                            display: {
                              xl: "flex",
                              lg: "flex",
                              md: "flex",
                              sm: "flex",
                              xs: "none",
                            },
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              display: {
                                xl: "flex",
                                lg: "flex",
                                md: "flex",
                                sm: "flex",
                                xs: "none",
                              },
                            }}
                          >
                            Instant page loading for smooth interactions.
                          </Typography>
                          {/* <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              display: {
                                xl: "none",
                                lg: "none",
                                md: "none",
                                sm: "none",
                                xs: "flex",
                              },
                            }}
                          >
                            Instant loading for smooth interactions.
                          </Typography> */}
                        </Stack>

                        {/* <Stack
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              display: {
                                xl: "flex",
                                lg: "flex",
                                md: "none",
                                sm: "flex",
                                xs: "none",
                              },
                            }}
                          >
                            Keep customers engaged within WhatsApp seamlessly.
                          </Typography>
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              display: {
                                xl: "none",
                                lg: "none",
                                md: "flex",
                                sm: "none",
                                xs: "flex",
                              },
                            }}
                          >
                            Customers engaged within WhatsApp.
                          </Typography>
                        </Stack> */}

                        <Stack
                          sx={{
                            display: {
                              xs: "none", // Hide on extra small screens
                              sm: "none", // Hide on small screens
                              md: "flex", // Show on medium and larger screens
                              lg: "none",
                              xl: "flex",
                            },
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              display: {
                                xl: "flex",
                                lg: "flex",
                                md: "none",
                                sm: "flex",
                                xs: "none",
                              },
                            }}
                          >
                            Complete transactions directly in WhatsApp chat.
                          </Typography>
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              display: {
                                xl: "none",
                                lg: "none",
                                md: "flex",
                                sm: "none",
                                xs: "none",
                              },
                            }}
                          >
                            Complete transactions form WhatsApp chat.
                          </Typography>
                        </Stack>

                        <Stack
                          sx={{
                            display: {
                              xs: "none", // Hide on extra small screens
                              sm: "none", // Hide on small screens
                              md: "flex", // Show on medium and larger screens
                              lg: "none",
                              xl: "flex",
                            },
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                            // border: "3px solid red",
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              display: {
                                xl: "flex",
                                lg: "flex",
                                md: "none",
                                sm: "flex",
                                xs: "flex",
                              },
                            }}
                          >
                            Retain users for seamless shopping experiences.
                          </Typography>
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              display: {
                                xl: "none",
                                lg: "none",
                                md: "flex",
                                sm: "none",
                                xs: "none",
                              },
                            }}
                          >
                            Retain users for seamless shopping.
                          </Typography>
                        </Stack>
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        // border: "1px solid red",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        // paddingLeft: "40px",
                        paddingLeft: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "12px",
                          sm: "40px",
                        },
                      }}
                    >
                      {/* <Button
                        variant="contained"
                        startIcon={<FaInfoCircle style={{ color: "white" }} />}
                        // sx={{
                        //   backgroundColor: "rgb(31,133,192)",
                        //   textTransform: "none",
                        //   borderRadius: "8px",
                        //   boxShadow:
                        //     "0 4px 8px rgba(0,0,0,0.2), 0 1px 3px rgba(0,0,0,0.1)",
                        // }}
                        sx={{
                          textTransform: "none",
                          borderRadius: "8px",
                          backgroundColor: "rgb(5, 78, 146)", // Initial background
                          color: "white", // Text color
                          borderColor: "rgb(5, 78, 146)", // Border same as background
                          boxShadow:
                            "0 4px 8px rgba(0,0,0,0.2), 0 1px 3px rgba(0,0,0,0.1)",

                          "&:hover": {
                            backgroundColor: "rgb(31, 133, 192)", // Hover background
                            borderColor: "rgb(31, 133, 192)", // Hover border
                          },
                        }}
                        size="large"
                        onClick={handleClick5}
                      >
                        Know more
                      </Button> */}
                    </Stack>
                  </Stack>
                </Stack>

                {/* image */}
              </Stack>
            </Box>
          </Grid>
        </Box>
      </Box>
    </Stack>
  );
};

export default MainCardMobile;
